const TopStatusTabs = ({
  items = [
    "PRODUCT PAGE",
    "GPT & SALES AGENT",
    "ALGORITHM",
    "SMS AND EMAIL SALES AGENT",
    "GPT & SALES AGENT",
  ],
  activeItem = "",
  className = "",
}) => {
  return (
    <div className={`hidden md:block w-full overflow-x-auto ${className}`}>
      <div className="flex min-w-max justify-center gap-3">
        {items.map((item, index) => {
          const isActive = item === activeItem;

          return (
            <div
              key={`${item}-${index}`}
              className={[
                "min-w-[240px] md:min-w-[270px] rounded-[4px] px-4 py-3",
                "text-center text-[10px] font-normal uppercase tracking-[0.05em]",
                "whitespace-nowrap text-[#1A1A1A]",
                isActive ? "bg-[#C5DDFF]" : "bg-[#F7F5F2]",
              ].join(" ")}
            >
              {item}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TopStatusTabs;
